export const SUFIXOS_PADRAO_DO_VALOR_RANGE = ['_de', '_ate'];

export const COMPONENTE_VALOR_RANGE = 'inputs/ValorRange';

export function sufixosDoValorRange(campo) {
  const declarados = campo?.parametros?.sufixos;

  if (!Array.isArray(declarados) || declarados.length !== 2) return SUFIXOS_PADRAO_DO_VALOR_RANGE;
  if (declarados.some(sufixo => typeof sufixo !== 'string' || sufixo === '')) {
    return SUFIXOS_PADRAO_DO_VALOR_RANGE;
  }

  return declarados;
}

export function parametrosDoValorRange(campo) {
  const [sufixoDe, sufixoAte] = sufixosDoValorRange(campo);

  return [`${campo.filtro}${sufixoDe}`, `${campo.filtro}${sufixoAte}`];
}
